import React from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';

import { Link } from 'react-router-dom';
import {
  MdThumbUp,
  MdThumbUpOffAlt,
  MdThumbDown,
  MdThumbDownOffAlt,
  MdOutlineComment,
} from 'react-icons/md';

import {
  ArticleThreadItem,
  DivThreadItem,
  DivThreadItemBody,
  ImageThreadItem,
  SpanCircle,
  ThreadItemCreatedAt,
  ThreadItemTitle,
  VoteThreadButton,
} from '../../styled';
import { showFormattedDate } from '../../../utils';
import { URL_THREAD_DETAIL } from '../../../utils/common/constant';

const ThreadItem = ({
  id,
  title,
  createdAt,
  body,
  downVotesBy,
  upVotesBy,
  user,
  totalComments,
  onDownVoteThread,
  onNeutralVoteThread,
  onUpVoteThread,
}) => {
  const { authUser } = useSelector((states) => states);
  const { name, avatar } = user;

  const downVoteLength = downVotesBy.length;
  const upVoteLength = upVotesBy.length;

  const upVoted = upVotesBy.find((upVote) => upVote === authUser.id);
  const downVoted = downVotesBy.find((downVote) => downVote === authUser.id);

  return (
    <ArticleThreadItem>
      <DivThreadItem>
        <ImageThreadItem src={avatar} alt="Avatar" />
        &nbsp;&nbsp;
        <ThreadItemCreatedAt>
          @
          {name}
        </ThreadItemCreatedAt>
        &nbsp;&nbsp;
        <SpanCircle>·</SpanCircle>
        &nbsp;&nbsp;
        <ThreadItemCreatedAt>{showFormattedDate(createdAt)}</ThreadItemCreatedAt>
      </DivThreadItem>
      <DivThreadItem>
        <ThreadItemTitle className="thread-item__title"><Link to={`${URL_THREAD_DETAIL}/${id}`}>{title}</Link></ThreadItemTitle>
      </DivThreadItem>

      <DivThreadItemBody dangerouslySetInnerHTML={{ __html: body }} />
      <DivThreadItem>
        {upVoted !== undefined
          ? <VoteThreadButton type="button" aria-label="up-votes" title="up-votes" onClick={() => onNeutralVoteThread({ id })}><MdThumbUp className="thread-icon" /></VoteThreadButton>
          : <VoteThreadButton type="button" aria-label="up-votes" title="up-votes" onClick={() => onUpVoteThread({ id })}><MdThumbUpOffAlt className="thread-icon" /></VoteThreadButton>}
        <ThreadItemCreatedAt>{upVoteLength}</ThreadItemCreatedAt>
        &nbsp;&nbsp;&nbsp;&nbsp;
        {downVoted !== undefined
          ? <VoteThreadButton type="button" aria-label="down-votes" title="down-votes" onClick={() => onNeutralVoteThread({ id })}><MdThumbDown className="thread-icon" /></VoteThreadButton>
          : <VoteThreadButton type="button" aria-label="down-votes" title="down-votes" onClick={() => onDownVoteThread({ id })}><MdThumbDownOffAlt className="thread-icon" /></VoteThreadButton>}
        <ThreadItemCreatedAt>{downVoteLength}</ThreadItemCreatedAt>
        &nbsp;&nbsp;&nbsp;&nbsp;
        <MdOutlineComment />
        <ThreadItemCreatedAt>{totalComments}</ThreadItemCreatedAt>
      </DivThreadItem>
    </ArticleThreadItem>
  );
};

const userShape = {
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
};

const threadItemShape = {
  id: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  createdAt: PropTypes.string.isRequired,
  body: PropTypes.string.isRequired,
  downVotesBy: PropTypes.array,
  upVotesBy: PropTypes.array,
  user: PropTypes.shape(userShape).isRequired,
  totalComments: PropTypes.number.isRequired,
  onDownVoteThread: PropTypes.func,
  onNeutralVoteThread: PropTypes.func,
  onUpVoteThread: PropTypes.func,
};

ThreadItem.propTypes = {
  ...threadItemShape,
};

export { threadItemShape };
export default ThreadItem;
